import * as React from 'react'
import { collectionsStore as store } from '../../collections.store'
import { ITabsModalProps } from '../tabs.interfaces'
import './tabs-department-modal.scss'

export const TabsDepartmentModal = ({ proceed }: ITabsModalProps): JSX.Element => {
  const baseClass: string = 'tabs-department-modal'

  return (
    <div className={baseClass} style={{ padding: '30px' }}>
      <h3>department</h3>
      <button
        className="btn"
        onClick={proceed}
        id="accept-continue"
      >
        Accept and continue
      </button>
    </div>
  )
}
